import {Component, EventEmitter, Injector, Input, Output} from '@angular/core';
import {MatBottomSheetRef} from "@angular/material/bottom-sheet";
import {SideSheetRef} from "@app/presentation/services/side-sheet/side-sheet-ref";
import {ExitService} from "@app/presentation/services/exit.service";


@Component({
  selector: 'custom-app-bar',
  templateUrl: './app-bar.component.html',
  styleUrls: ['./app-bar.component.scss']
})
export class AppBarComponent {

  @Input() hasBackButton = false;
  @Input() hasCloseButton = false;
  @Input() hasSaveButton = false;
  @Input() hasPlusButton = false;
  @Input() title?= ''
  @Input() hasSafeArea = true

  @Input() customButtonIconSvgPath?: string;

  @Input() customButtonText?: string;

  @Input() appearance: 'inverted' | 'default' = 'default';

  @Output() onClickBackButton = new EventEmitter<void>();

  @Output() onClickCloseButton = new EventEmitter<void>();

  @Output() onClickSaveButton = new EventEmitter<void>();

  @Output() onClickPlusButton = new EventEmitter<void>();

  @Output() onClickCustomButtonIcon = new EventEmitter<void>();

  @Output() onClickCustomButtonText = new EventEmitter<void>();

  @Input() backButtonReturnToThePreviousPage = true;

  @Input() closeButtonReturnToThePreviousPage = true;

  @Input() isLoading: boolean | null = false;

  @Input() isSuccessful: boolean | null = false;

  bottomSheetRef?: MatBottomSheetRef;

  sideSheetRef?: SideSheetRef;

  constructor(
    private injector: Injector,
  ) {
    try {
      this.bottomSheetRef = injector.get(MatBottomSheetRef);
    } catch { }

    try {
      this.sideSheetRef = injector.get(SideSheetRef);
    } catch { }
  }

  public _onClickBackButton() {
    if (this.backButtonReturnToThePreviousPage) { this.back() }
    this.onClickBackButton.emit();
  }

  public _onClickCloseButton() {
    if (this.closeButtonReturnToThePreviousPage) { this.closePage() }
    this.onClickCloseButton.emit();
  }

  public _onClickSaveButton() {
    this.onClickSaveButton.emit();
  }

  public _onClickPlusButton() {
    this.onClickPlusButton.emit();
  }

  public _onClickCustomButtonIcon() {
    this.onClickCustomButtonIcon.emit();
  }

  public _onClickCustomButtonText() {
    this.onClickCustomButtonText.emit();
  }

  private back() {
    ExitService.back(this.injector)
  }

  private closePage() {
    ExitService.exit(this.injector)
  }

}
